import React from "react";

export const Header = (props) => {
  const mainId = props.data?.main?.toLowerCase().replace(/ /g, "_") || "loading...";
  const titleLines = props.data?.title?.split("\n") || [];
  const paragraphs = props.data?.paragraphs || [];
  const ctaAnchor = props.data?.cta_d?.toLowerCase().replace(/ /g, "_") || "#";
  const ctaText = props.data?.cta || "Loading";

  return (
    <header id={mainId}>
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-12 intro-text">
                {/* Renderizar el título con saltos de línea */}
                <h1>
                  {titleLines.length > 0
                    ? titleLines.map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))
                    : "Loading"}
                </h1>

                {/* Renderizar los párrafos */}
                {paragraphs.length > 0
                  ? paragraphs.map((item, i) => <h3 key={i}>{item}</h3>)
                  : "Loading"}

                {/* Botón "Saber Más" */}
                <a href={`#${ctaAnchor}`} className="btn btn-custom btn-lg page-scroll">
                  {ctaText}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
